import { useState, useContext } from "react";
import EventContext from "../store/event-context";
import ActorInput from "./actorInput";
import ActorInWaveList from "./actorInWaveList";
import { Box } from "@mui/material";
import useActor from "../services/actorService";
import AlertDialog from './alertDialog';
import { CircularProgress } from "@mui/material";

const ActorIn = () => {

  // Functions and data of actor
  const {
    actorData,
    resetActor,
    isLoadingActor,
    actorServerError,
    fetchActor,
    fetchActorByWave,
    actorStateChange,
  } = useActor();

  const eventctx = useContext(EventContext);
  const haveColor = eventctx.event.colors.length > 1;

  // This is where 'fetchActor' is called. This function is provided by useActor.
  const searchLocalActor = (capnr, color) => {
    console.log(`Looking for actor ${color}:${capnr}`);
    fetchActor(color ? `${color}:${capnr}` : capnr);
  };

  const searchActorByWave = (wave) => {
      console.log(`Looking for actors in wave: $wave`);
      fetchActorByWave(wave);
    };

  const [showAlert, setShowAlert] = useState(true);

  const afterCloseAlert = () => {
    resetActor();
    setShowAlert(true);
  }

  return (
    <Box height="100%" id="ActorIn">
      <Box id="ActorInputBox" sx={{marginTop: '10px'}} >
        {/* Below the input of Capnr.
            With in there the button (form submit) that calls "lookupactor" (here local searchLocalActor).
            In there it calls fetchFactor that finally updates actorData.
        */}
        <ActorInput lookupActor={searchLocalActor} isLoading={isLoadingActor} haveColor={haveColor}/>
      </Box>
      <Box height="80%" id="ActorInWaveListOuterBox">
        {/* This is where the list of actors is displayed.
            With the actorData it also displays the Teamnaam and the 1e entry in the list.
            With the button [Iedereen] the list is completed with the rest of the team members.
        */}
        <ActorInWaveList actor={actorData} isLoading={isLoadingActor} haveColor={haveColor} clearActor={resetActor}/>
      </Box>
      {actorServerError && showAlert && <AlertDialog
        onClose={afterCloseAlert}
        message={actorServerError}
        severity="warning"
        />}
      {isLoadingActor && <CircularProgress color="inherit" />}
    </Box>
  );
};

export default ActorIn;
